import { render, staticRenderFns } from "./mono.vue?vue&type=template&id=31bbdbc2&scoped=true&"
import script from "./mono.vue?vue&type=script&lang=js&"
export * from "./mono.vue?vue&type=script&lang=js&"
import style0 from "./mono.vue?vue&type=style&index=0&id=31bbdbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bbdbc2",
  null
  
)

export default component.exports